import { Children, cloneElement, useEffect } from 'react';

import { playSound, Sound } from '~/assets/sounds';
import { useInputAction } from '~/rage';
import { InputAction } from '~/shared';

import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import {
	setVehicleTabIndex,
	setVehicleTabIndexNext,
	setVehicleTabIndexPrev,
} from '../../redux/slices/modalSlice';
import { TabLine } from '../TabLine';
import { StyledContainer } from './TabsContainer.styled';

const TabsContainer = ({
	children,
	...props
}: React.HTMLAttributes<HTMLDivElement>) => {
	const dispatch = useLayoutDispatch();
	const vehicleTabIndex = useLayoutSelector(
		(state) => state.modal.vehicleTabIndex,
	);

	useInputAction(InputAction.CommonTabNavLeft, () =>
		dispatch(setVehicleTabIndexPrev()),
	);
	useInputAction(InputAction.CommonTabNavRight, () =>
		dispatch(setVehicleTabIndexNext()),
	);

	const updateTabLine = () => {
		const tabElement = document.getElementById(`tab#${vehicleTabIndex}`);
		const lineElement = document.getElementById(`tab#line`);

		if (tabElement !== null && lineElement !== null) {
			const tabWidth = window.getComputedStyle(tabElement).width;
			lineElement.style.setProperty('--width', tabWidth);
			lineElement.style.setProperty('--left', `${tabElement.offsetLeft}px`);
		}
	};

	useEffect(() => {
		const tabElement = document.getElementById(`tab#${vehicleTabIndex}`);
		if (tabElement !== null) {
			tabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	}, [vehicleTabIndex]);

	useEffect(() => {
		updateTabLine();

		const timeoutId = setTimeout(updateTabLine, 0);

		return () => clearTimeout(timeoutId);
	}, [vehicleTabIndex]);

	return (
		<StyledContainer {...props}>
			{Children.map(children, (child: any, index) => {
				return cloneElement(child, {
					id: `tab#${index}`,
					onClick: () => {
						dispatch(setVehicleTabIndex(index));
						playSound(Sound.ClickButton);
					},
					$selected: index == vehicleTabIndex,
				});
			})}
			<TabLine id="tab#line" />
		</StyledContainer>
	);
};

export { TabsContainer };
